import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ZipmapRepository from "../../repository/ZipmapRepository";
import DashboardSideNav from "./DashboardSideNav";
import EditButton from "../../shared/components/dashboard/EditButton";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CoorayFooter from "../../shared/components/footer/CoorayFooter";
import DashboardPageEditMap from "./DashboardPageEditMap";
import DashboardTabs from "./DashboardTabs";
import DashboardPageEditPlaces from "./DashboardPageEditPlaces";
import DashboardPageAnalytics from "./DashboardPageAnalytics";
import DashboardPageMembers from "./DashboardPageMembers";

export default function DashboardPageMain({ analytics, viewingMap, onMapUpdated, onMapDeleted }) {

    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState(1)
    const [fullScreenLoadingText, setFullScreenLoadingText] = useState(null)
    useEffect(() => {
    }, [viewingMap])

    return (
        <div className="h-full flex-1 relative flex flex-col">
            <div className="flex flex-col flex-1 bg-base-200 overflow-y-scroll overscroll-contain">
                <div className="absolute top-4 left-0 w-full z-10 text-center"><DashboardTabs activeTab={activeTab} setActiveTab={setActiveTab} /></div>
                <div className="pt-16 w-full">
                {
                    activeTab == 1 && <DashboardPageEditMap 
                    analytics={analytics} 
                    viewingMap={viewingMap} 
                    setFullScreenLoadingText={setFullScreenLoadingText} 
                    onMapUpdated={onMapUpdated} 
                    onMapDeleted={onMapDeleted}
                    />
                }
                {
                    activeTab == 2 && <DashboardPageEditPlaces analytics={analytics} viewingMap={viewingMap} setFullScreenLoadingText={setFullScreenLoadingText} />
                }
                {
                    activeTab == 3 && <DashboardPageAnalytics analytics={analytics} viewingMap={viewingMap} />
                }
                {
                    activeTab == 4 && <DashboardPageMembers viewingMap={viewingMap} />
                }
                </div>
            </div>
            {
                fullScreenLoadingText &&
                <div className='w-full h-screen absolute max-w-[100%] top-0 flex flex-row items-center justify-center gap-2 backdrop-blur-sm bg-base-100/30 z-50'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content'>{fullScreenLoadingText}</div>
                </div>
            }
        </div>
    )
}
